export const mockSignInFormProps = {
  signInLabel: 'Sign In',
  memberNumberLabel: 'Member Number or Email',
  loginPasswordLabel: 'Password',
  loginPasswordPlaceHolder: 'Enter your password',
  remeberMeLabel: 'Remember Me',
  signInButtonLabel: 'Sign In',
  signInButtonUrl: '/api/mock-sign-in', // mock API endpoint
  forgotPasswordLinkLabel: 'Forgot Password?',
  forgotPasswordLinkPath: '/forgotPassword.mi',
  activateAccountLinkLabel: 'Activate Online Account',
  activeAccountLinkUrl: '/activate-account',
  clearRememberedAccountLabel: 'Clear Remembered Account',
  clearRememberedAccountUrl: '/api/clear-remembered',
  welcomeText: 'Welcome back,',
  signInSubHeading: 'Please confirm your password to continue.',
  signInErrorMessages: {
    uxlFailureErrorMessage: 'Something went wrong. Please try again.',
  },
  joinNowLabel: 'Not a Member?',
  joinNowSubHeading: 'Join now and start earning rewards today.',
  becomeMemberLabel: 'Join Now',
  becomeMemberUrl: '/join-now',
  ariaLabelId: 'signInHeading',
};
export const signInErrorMessages = {
  errorForUserName: 'Email is required.',
  errorForPassword: 'Password is required.',
  pwrdErrorMessage:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
  emailErrorLabel:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
  signInPageWarnMessage:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
  warningMessage:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
  lockoutWarningMessage:
    '<p>You have one attempt remaining to enter the correct username/password before your account is locked.</p>\r\n',
  auditWarningMessage:
    "<p>Your account has been locked. We've detected suspicious activity on your account. For assistance, call Marriott Bonvoy at 1 (800) 535-4028 in the US and Canada. Or, contact the global customer support center nearest you.</p>\r\n",
  credentialsWarningMessage:
    '<p>Please correct the following and try again: Mobile Number/Email/Member Number and/or Password</p>\r\n',
  lockedWarningMessage:
    '<p>You are temporarily locked out of your account. Please wait 30 minutes before entering your information again or using the Forgot Password link below.</p>\r\n',
  invalidEmailOrMemberError:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
  otpLockedOutErrorMessage:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
  uxlFailureErrorMessage:
    '<p>Please correct the following and try again: Email/Member number and/or password. <a href="https://help.marriott.com/s/article/Article-22182" target="_blank"><b><u>Get help</u></b></a>↗ signing in.</p>\r\n',
};
